const Audio = function (game) {
  const files = [];
  const endEvents = [];
  const progressEvents = [];
  let playing = [];

  function progress(event, name, callback) {
    if (event.loaded === event.total && typeof callback === 'function') {
      callback();
      files[name].removeEventListener('canplaythrough', progressEvents[name], true);
    }
  }

  function load(name, path, cb) {
    progressEvents[name] = function (event) {
      progress(event, name, cb);
    };

    const f = document.createElement('audio');
    f.addEventListener('canplaythrough', progressEvents[name], true);
    f.setAttribute('preload', 'true');
    f.setAttribute('autobuffer', 'true');
    f.setAttribute('src', path);
    f.pause();

    if (name === 'music') {
      f.setAttribute('loop', 'true');
    }

    files[name] = f;
  }

  function disableSound() {
    for (let i = 0; i < playing.length; i++) {
      files[playing[i]].pause();
      // files[playing[i]].currentTime = 0;
    }
    playing = [];
  }

  function ended(name) {
    const tmp = [];
    let found = false;

    files[name].removeEventListener('ended', endEvents[name], true);

    for (let i = 0; i < playing.length; i++) {
      if (!found && playing[i]) {
        found = true;
      } else {
        tmp.push(playing[i]);
      }
    }
    playing = tmp;
  }

  function play(name) {
    if (!game.soundDisabled()) {
      endEvents[name] = () => {
        ended(name);
      };
      playing.push(name);
      files[name].addEventListener('ended', endEvents[name], true);
      files[name].play();
    }
  }

  function pause() {
    for (let i = 0; i < playing.length; i++) {
      files[playing[i]].pause();
    }
  }

  function stop(name) {
    files[name].pause();
    files[name].currentTime = 0;
    ended(name);
  }

  function resume() {
    for (let i = 0; i < playing.length; i++) {
      files[playing[i]].play();
    }
  }

  return {
    disableSound,
    load,
    play,
    stop,
    pause,
    resume,
  };
};

module.exports = Audio;



// WEBPACK FOOTER //
// ./_components/hero-halloween-block/audio.js